import type { AgeGroup, Prompt } from "./types";

/** ponytail: mulberry32 — fine for prompt shuffle; upgrade if crypto-grade needed */
function hashSeed(seed: string): number {
  let h = 1779033703 ^ seed.length;
  for (let i = 0; i < seed.length; i++) {
    h = Math.imul(h ^ seed.charCodeAt(i), 3432918353);
    h = (h << 13) | (h >>> 19);
  }
  return h >>> 0;
}

function mulberry32(a: number): number {
  let t = (a + 0x6d2b79f5) >>> 0;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

export function seededShuffle<T>(items: readonly T[], seed: string): T[] {
  const arr = [...items];
  let state = hashSeed(seed);
  for (let i = arr.length - 1; i > 0; i--) {
    state = Math.floor(mulberry32(state) * 4294967296);
    const j = state % (i + 1);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export function localDateKey(date = new Date()): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function dayIndexFromDate(date = new Date()): number {
  const local = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  return Math.floor(local.getTime() / 86_400_000);
}

export function promptForDay(
  prompts: readonly Prompt[],
  ageGroup: AgeGroup,
  seed: string,
  dayIndex = dayIndexFromDate(),
): Prompt {
  const pool = prompts.filter((p) => p.ageGroup === ageGroup);
  if (pool.length === 0) throw new Error(`Geen prompts voor leeftijd ${ageGroup}`);
  const shuffledIds = seededShuffle(
    pool.map((p) => p.id),
    seed,
  );
  const id = shuffledIds[dayIndex % shuffledIds.length]!;
  const prompt = pool.find((p) => p.id === id);
  if (!prompt) throw new Error(`Prompt ${id} niet gevonden`);
  return prompt;
}

export function cycleLength(ageGroup: AgeGroup, prompts: readonly Prompt[]): number {
  return prompts.filter((p) => p.ageGroup === ageGroup).length;
}
